/**
Coded by www.techhighway.ca

*/

import { forwardRef } from "react";

// prop-types is a library for typechecking of props
import FormControlLabel from "@mui/material/FormControlLabel";
import PropTypes from "prop-types";

// Custom styles for MDButton
import MDSwitchRoot from "components/MDSwitch/MDSwitchRoot";

// Material Dashboard 2 React contexts
import { useMaterialUIController } from "context";

const MDSwitch = forwardRef(
  ({ label, checked, color, defaultChecked, disabled, size, labelPlacement, ...rest }, ref) => {
    const [controller] = useMaterialUIController();
    return (
      <FormControlLabel
        sx={{ marginRight: "0px", marginLeft: "0px" }}
        control={
          <MDSwitchRoot
            {...rest}
            ref={ref}
            checked={checked}
            color={color}
            size={size}
            disabled={disabled}
            ownerState={{ checked, color, defaultChecked, disabled, size }}
          />
        }
        label={label || ""}
        labelPlacement={labelPlacement}
      />
    );
  }
);

// Setting default values for the props of MDButton
MDSwitch.defaultProps = {
  color: "primary",
  defaultChecked: "",
  disabled: false,
  size: "small",
  labelPlacement: "start",
};

// Typechecking props for the MDButton
MDSwitch.propTypes = {
  size: PropTypes.oneOf(["small", "medium"]),
  color: PropTypes.oneOf(["primary", "secondary", "error", "info", "success", "warning"]),
};

export default MDSwitch;
